import type { ComposantEcran } from '../../app/ecrans.js';
import { EcranDossier } from './EcranDossier.js';

/** Écrans du lot L53, lus par `import.meta.glob('../features/*\/index.{ts,tsx}')` de la coquille. */
export const ecrans: Readonly<Record<string, ComposantEcran>> = { D03: EcranDossier };
